const e = "公寓式酒店", s = "公寓", t = "商务", o = "露营地", n = "情侣", i = "家庭", r = "朋友", a = "旅舍", l = "酒店", c = "度假村", m = "餐馆", u = {
  "{num} reviews": "{num}评论",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType}中的 {location｝",
  "All languages": "所有语言",
  "All traveler types": "所有旅客类型",
  Aparthotels: e,
  Apartments: s,
  "Arrow icon": "箭头图标",
  "B&Bs": "民宿",
  "based on {number} reviews": "基于{number}评论",
  Business: t,
  Campsites: o,
  Couple: n,
  Family: i,
  Friend: r,
  "Highlighted reviews": "重点评论",
  Hostels: a,
  Hotels: l,
  "Information icon": "信息图标",
  "No reviews found": "未找到评论",
  "Pet-friendly": "宠物友好",
  "Posted on {reviewer}": "发布于 {reviewer｝",
  "Read Reviews": "阅读评论",
  Resorts: c,
  Restaurants: m,
  "Review Summary": "评价概要",
  "Reviews by Source": "按来源分类的评论"
};
export {
  e as Aparthotels,
  s as Apartments,
  t as Business,
  o as Campsites,
  n as Couple,
  i as Family,
  r as Friend,
  a as Hostels,
  l as Hotels,
  c as Resorts,
  m as Restaurants,
  u as default
};
//# sourceMappingURL=zh.BGDxLBAq.js.map
